export enum DocumentShowState {
  UNSET = 1,
  PREVIOUS ,
  NEXT ,
  SPECIFIC
}
